import { Component } from '@angular/core';

@Component({
  selector: 'app-test',
  template: `<p>test works! {{ 'i18n.sidebar.logout' | translate }}</p>`,
})
export class TestComponent {}
